import { render, staticRenderFns } from "./RuleChooseBox.vue?vue&type=template&id=38e9bfc2&scoped=true&"
import script from "./RuleChooseBox.vue?vue&type=script&lang=js&"
export * from "./RuleChooseBox.vue?vue&type=script&lang=js&"
import style0 from "./RuleChooseBox.vue?vue&type=style&index=0&id=38e9bfc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../salespro-dev/salespro-dev/sources/client/salespro-dev-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e9bfc2",
  null
  
)

export default component.exports